import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../providers/auth.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

  regForm: NgForm;
  @ViewChild('regForm') newForm: NgForm;

  email: String;
  name: String;
  password: String;
  confirm: String;
  ready: Boolean = false;

  objectKeys = Object.keys;

  constructor(public authService: AuthService, private router: Router) {
    // console.log('register constructor');
  }
  ngOnInit() { }

  onSubmit() {
    console.log('register: ' + this.toString());
    this.authService.register(this.email, this.password).then(
      (user?) => {
        console.log('resolved: ' + JSON.stringify(user));
        user.updateProfile({displayName: this.name});
        user.sendEmailVerification();
        this.router.navigate(['home']);
      },
      (err) => {
        console.log('rejected');
        this.formErrors['Error'] = err.message;
        this.ready = false;
      }
    );
  }

  toString() {
    return 'RegForm: ' + this.email + ", " + this.name + ', ' + this.password;
  }


  ngAfterViewChecked() {
    if (this.newForm === this.regForm) { return; }
    // console.log('form has changed');
    this.regForm = this.newForm;
    if (this.regForm) {
      this.regForm.valueChanges.subscribe(data => this.onValueChanged(data));
    }
  }

  onValueChanged(data?: any) {
    if (!this.regForm) { return; }
    const form = this.regForm.form;

    for (const field in this.formErrors) {
      // clear previous error message (if any)
      this.formErrors[field] = '';
      const control = form.get(field);

      if (control && control.dirty && !control.valid) {
        for (const key in control.errors) {
          this.formErrors[field] += this.messages[field][key] + ' ';
        }
      }
    }
    this.ready = form.valid;
    if (form.valid) {
      if (this.password !== this.confirm) {
        this.ready = false;
        this.formErrors['password'] += this.messages['password']['match'];
      }
    }
  }

  formErrors = {
    'name': '',
    'email': '',
    'password': '',
    'confirm': ''
  };
  messages = {
    'name': {
      'required': 'Name is required.',
      'minlength': 'Name must be at least 4 characters long.',
      'maxlength': 'Name cannot be more than 24 characters long.',
      'forbiddenName': 'Someone named "Bob" cannot be a hero.'
    },
    'email': {
      'required': 'email is required.'
    },
    'password': {
      'required': 'password is required.',
      'pattern': 'password must be complicated',
      'match': 'password confirmation does not  match'
    },
    'confirm': {
      'required': 'password confirmation is required.',
      'pattern': 'password must be complicated'
    }
  };
}



// WEBPACK FOOTER //
// /var/www/html/mediate/src/app/register/register.component.ts